import { MenuItem, TextField } from '@mui/material';
import { useVariantUnits } from '../sales/lib/api';

/** The unit a line is returned in, with base units per unit. */
export interface PickedUnit {
  unitId: string;
  symbol: string;
  factor: string;
}

/**
 * Pick another unit of the item to return in (1 box sold, 50 pc back). The line's own unit keeps
 * the factor it was sold or bought at. Nothing is shown when the item has a single unit.
 */
export function UnitPick({
  line,
  value,
  onChange,
}: {
  line: {
    sku: string;
    variantId: string;
    description: string;
    unitId: string;
    unitSymbol: string;
    factor: string;
  };
  value: PickedUnit;
  onChange: (unit: PickedUnit) => void;
}) {
  const units = useVariantUnits(line);
  const options: PickedUnit[] = [
    { unitId: line.unitId, symbol: line.unitSymbol, factor: line.factor },
    ...units.filter((u) => u.unitId !== line.unitId),
  ];
  if (options.length < 2) return null;
  return (
    <TextField
      select
      size="small"
      value={value.unitId}
      onChange={(e) => {
        const unit = options.find((o) => o.unitId === e.target.value);
        if (unit) onChange(unit);
      }}
      sx={{ width: 120, mt: 0.75 }}
      slotProps={{ htmlInput: { 'aria-label': `Unit of ${line.description} returned` } }}
    >
      {options.map((o) => (
        <MenuItem key={o.unitId} value={o.unitId}>
          {o.symbol}
        </MenuItem>
      ))}
    </TextField>
  );
}
